import { useFormikContext } from 'formik';
import { observer } from 'mobx-react';
import { useContext } from 'react';
import { Button, Form, Spinner } from 'react-bootstrap';
import { storesContext } from '../../../../stores/storesContext';
import PropertySelect from '../../../helpers/PropertySelect';
import StationSelect from '../../../helpers/StationSelect';
import BlockMapEditable from './BlockMapEditable';

const BlockForm = ({ onCancel, showPropertySelect }) => {
  const userStore = useContext(storesContext);
  const alcmStore = userStore.alcmStore;
  const propertiesStore = userStore.propertiesStore;

  const {
    values,
    errors,
    isSubmitting,
    handleSubmit,
    handleChange,
    handleBlur,
    setFieldValue
  } = useFormikContext();

  return (
    <>
      <Form noValidate onSubmit={handleSubmit}>
        <Form.Group className='mb-3' controlId='block_id'>
          <Form.Label>Block ID</Form.Label>
          <Form.Control
            type='text'
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.block_id || ''}
            placeholder=''
            isInvalid={!!errors.block_id}
          />
          <Form.Control.Feedback type='invalid'>
            {errors.block_id}
          </Form.Control.Feedback>
        </Form.Group>
        {showPropertySelect ? (
          <Form.Group className='mb-3' controlId='property_ud'>
            <Form.Label>Property</Form.Label>
            <PropertySelect
              property={propertiesStore.properties.find(
                (p) => p.id === values.property_id
              )}
              properties={propertiesStore.properties}
              onChange={(option) => {
                setFieldValue('property_id', option.value);
              }}
            />
            <Form.Control.Feedback type='invalid'>
              {errors.property}
            </Form.Control.Feedback>
          </Form.Group>
        ) : null}
        <Form.Group className='mb-3' controlId='station_id'>
          <Form.Label>Station</Form.Label>
          <StationSelect
            station={alcmStore.stations.find(
              (s) => s.Station_ID === values.station_id
            )}
            stations={alcmStore.stations}
            onChange={(option) => {
              setFieldValue('station_id', option.value);
            }}
            isInvalid={!!errors.station_id}
          />
          {errors.station_id && (
            <div className='text-danger small mt-1'>{errors.station_id}</div>
          )}
        </Form.Group>
        <Form.Group className='mb-3' controlId='variety'>
          <Form.Label>Variety</Form.Label>
          <Form.Control
            type='text'
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.variety || ''}
            placeholder=''
            isInvalid={!!errors.variety}
          />
          <Form.Control.Feedback type='invalid'>
            {errors.variety}
          </Form.Control.Feedback>
        </Form.Group>
        <Form.Group className='mb-3' controlId='rootstock'>
          <Form.Label>Rootstock</Form.Label>
          <Form.Control
            type='text'
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.rootstock || ''}
            placeholder=''
            isInvalid={!!errors.rootstock}
          />
          <Form.Control.Feedback type='invalid'>
            {errors.rootstock}
          </Form.Control.Feedback>
        </Form.Group>
        <Form.Group className='mb-3' controlId='g2_trap_catch_peak_date'>
          <Form.Label>G2 Trap Catch Peak</Form.Label>
          <Form.Control
            type='date'
            onChange={handleChange}
            onBlur={handleBlur}
            value={(values.g2_trap_catch_peak_date || '').slice(0, 10)}
            isInvalid={!!errors.g2_trap_catch_peak_date}
          />
          <Form.Control.Feedback type='invalid'>
            {errors.g2_trap_catch_peak_date}
          </Form.Control.Feedback>
        </Form.Group>
        <Form.Group className='mb-3' controlId='g2_egg_peak_date'>
          <Form.Label>G2 Egg Peak</Form.Label>
          <Form.Control
            type='date'
            onChange={handleChange}
            onBlur={handleBlur}
            value={(values.g2_egg_peak_date || '').slice(0, 10)}
            isInvalid={!!errors.g2_egg_peak_date}
          />
          <Form.Control.Feedback type='invalid'>
            {errors.g2_trap_catch_peak_date}
          </Form.Control.Feedback>
        </Form.Group>
        <Form.Group className='mb-3' controlId='geom'>
          <Form.Label>Block Boundary</Form.Label>
          <div style={{ height: '300px' }}>
            <BlockMapEditable
              geom={values.geom}
              onChange={(geom) => setFieldValue('geom', geom)}
            />
          </div>
        </Form.Group>
        <Button variant='primary' type='submit'>
          {isSubmitting ? (
            <Spinner className='mx-3' animation='border' size='sm' />
          ) : (
            'Submit'
          )}
        </Button>{' '}
        <Button variant='secondary' type='button' onClick={onCancel}>
          Cancel
        </Button>
      </Form>
    </>
  );
};

export default observer(BlockForm);

